package net.sergeych.ugdx.shared.api

import kotlinx.datetime.Instant
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import net.sergeych.mp_logger.LogEntry
import net.sergeych.mptools.Now
import net.sergeych.ugdx.shared.ApiOperation
import net.sergeych.ugdx.shared.trader.CandleStick
import net.sergeych.ugdx.shared.trader.StatSampleRate
import net.sergeych.ugdx.shared.trader.TradeOrder

@Serializable
data class IncompleteCandleStickData(
    val stick: CandleStick,
    val rate: StatSampleRate
)

@Serializable
sealed class PushPayload(val createdAt: Instant=Now()) {

    /**
     * Account os changed.
     * @param apiAccount new state of the account
     * @param operation optionally, the operation that changed the account. If null, account was changed without
     *                  performing operations, e.g. renamed, etc.
     */
    @Serializable
    @SerialName("acc")
    class AccountChanged(
        val apiAccount: ApiAccount,
        val operation: ApiOperation?
    ) : PushPayload()

    @Serializable
    @SerialName("trord")
    class TraderOrderChanged(
        val order: TradeOrder
    ): PushPayload()

    @Serializable
    @SerialName("dom")
    class DepthOfMarketChanged(
        val depthOfMarket: net.sergeych.ugdx.shared.trader.DepthOfMarket,
    ): PushPayload()

    @Serializable
    @SerialName("jcan")
    class JumpingCandleStick(
        val currencyPairLabel: String,
        val sampleRate: StatSampleRate,
        val startsAt: Instant,
        val candleStick: CandleStick
    ): PushPayload()

    @Serializable
    class SystemLog(val entry: LogEntry): PushPayload()
}